<template>
  <w-popup :state="actionSheetState" @handleClose="handleClose">
    <div slot="content" class="action-sheet-container">
      <div class="action-sheet-content">
        <p class="action-sheet-header content-copy" :data-clipboard-text="actionSheetData.content" @click="copy">{{ actionSheetData.content }}</p>
        <template v-for="(item,index) in operation">
          <div class="action-sheet-item flex-center content-copy" :key="index" :data-clipboard-text="actionSheetData.content"
               :class="{'high-light-text': highlightIndex === index}" @click="selectItem(item)">{{ item.text }}
          </div>
        </template>
      </div>
      <div class="action-sheet-cancel flex-center" @click="handleClose">取消</div>
    </div>
  </w-popup>
</template>

<script>
	import WPopup from '../../../components/global/w-popup'
	import Clipboard from 'clipboard'
	import { componentsMixin } from '../../../assets/js/mixin/components'

	export default {
		name: 'action-sheet',
		mixins: [ componentsMixin ],
		props: {
			actionSheetState: {
				type: Boolean,
				default: true
			},
			operation: {
				type: Array,
				default: () => [
					{ text: '复制', value: 'copy' },
					{ text: '删除', value: 'delete' }
				]
			},
			actionSheetData: {
				type: Object,
				default: () => {
					return {}
				}
			},
			highlightIndex: {
				type: Number,
				default: 1
			}
		},
		data () {
			return {}
		},
		mounted () {
		},
		computed: {},
		watch: {},
		components: {
			WPopup
		},
		methods: {
			handleClose () {
				this.$emit('handleClose')
			},
      copy () {
	      let clipboard = new Clipboard('.content-copy')
	      clipboard.on('success', e => {
		      this.showToast('已复制')
		      clipboard.destroy() // 释放内存
		      this.handleClose()
	      })
      },
			selectItem (item) {
				if (item.value === 'copy') {
					this.copy()
				} else {
					this.handleClose()
					this.$emit('selectItem', item)
				}
			}
		}
	}
</script>

<style lang="scss" scoped>
  @import "../../../assets/scss/global/variable";
  @import "../../../assets/scss/global/mixin";
  .w-popup {
    /deep/ .main {
      width: calc(100vw - 20px);
      background-color: transparent;
      margin-left: 10px;
      z-index: 313;
    }
    /deep/ .mask {
      z-index: 312;
    }
  }
  .action-sheet-container {
    width: calc(100vw - 20px);
    box-sizing: border-box;
    .action-sheet-content {
      padding: 0 28px;
      background-color: $color-light;
      border-radius: 10px;
      margin-bottom: 16px;
      .action-sheet-header {
        height: 48px;
        line-height: 48px;
        color: $color-light-gray;
        font-size: $font-size-small;
        @include ellipsis(100%);
      }
      .action-sheet-item {
        height: 55px;
        border-top: 1px solid #F9F9F9;
        font-size: $font-size-medium-x;
        color: $color-title;
      }
      .high-light-text {
        color: $color-theme;
      }
    }
    .action-sheet-cancel {
      background-color: $color-light;
      border-radius: 10px;
      height: 52px;
      font-size: $font-size-medium-x;
      color: $color-title;
      margin-bottom: 16px;
    }
  }
</style>
